import React from "react";
import ConfirmationProps from "./ConfirmationProps";
import BaseConfirmation from "./BaseComponent/BaseConfirmation";

export default (props: ConfirmationProps) => {
  return <BaseConfirmation btnType="destructive" {...props} />;
};
